import { TagImage } from '@fiverr-private/data_display';

export default TagImage;
